import { useNavigate } from 'react-router-dom'
import { useAmplitude } from '../../hooks/useAmplitude'
import { AmplitudeEvents } from '../../types/amplitude'
import type { GetStartedClickedProperties } from '../../types/amplitude'

export function FinalCTA() {
  const navigate = useNavigate()
  const { track } = useAmplitude()

  const handleGetStartedClick = () => {
    // Track the event
    const eventProperties: GetStartedClickedProperties = {
      url: window.location.href,
      description: 'simple-landing-page-test',
      location: 'final-cta',
      isAuthenticated: false, // This component always navigates to auth, so user is not authenticated
      timestamp: new Date().toISOString(),
    }
    track(AmplitudeEvents.GET_STARTED_CLICKED, eventProperties)

    // Navigate
    navigate('/auth')
  }

  return (
    <section className="final-cta-section">
      <div className="final-cta-container">
        <div className="final-cta-content">
          <h2 className="final-cta-title">Ready to get started?</h2>
          <div className="final-cta-button">
            <button className="get-started-btn hero-btn" onClick={handleGetStartedClick}>
              Get Started
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
